import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';

export function RegistrationMetaView({ title, description }: { title: string; description: string }) {
  return (
    <div
      className={vstack({
        gap: 8,
        py: 24,
        px: 16,
        bg: 'background.default.level-1',
      })}
    >
      <p
        className={css({
          textStyle: 'Title/S',
          color: 'content.default.level-5',
          textAlign: 'center',
        })}
      >
        {title}
      </p>
      <p
        className={css({
          textStyle: 'Text/M/Monospace/Regular',
          color: 'content.default.level-3',
          textAlign: 'center',
        })}
      >
        {description}
      </p>
    </div>
  );
}
